import { ListSubheader, MenuItem, TextField } from "@mui/material";
import Translate from "component/global/translation/translation-component";
import { useTranslation } from "react-i18next";
import { translateMetadataLabel } from "modules/record/shared/services/recordMetadataLabels";

interface FieldSelectorProps {
    value: string;
    columns: any[];
    onChange: (field: string) => void;
    ariaLabel?: string;
    columnGroups?: Record<string, { group: string; label: string }>;
}

export const FieldSelector = ({ value, columns, onChange, ariaLabel, columnGroups }: FieldSelectorProps) => {
    const { t } = useTranslation();
    let previousGroup = "";

    return (
        <TextField
            select
            size="small"
            value={value || ""} // Garantir que nunca seja undefined
            onChange={(e) => onChange(e.target.value)}
            inputProps={{ "aria-label": ariaLabel }}
            SelectProps={columnGroups ? {
                renderValue: (selected) => columns.find((col) => col.name === selected)?.label || "",
            } : undefined}
            sx={columnGroups ? {
                minWidth: 0,
                width: "100%",
                "& .MuiSelect-select": { whiteSpace: "normal", overflow: "visible", overflowWrap: "anywhere", height: "auto !important" },
            } : { minWidth: 160, width: "100%" }}
        >
            <MenuItem value="">
                <em><Translate text="Select field" /></em>
            </MenuItem>
            {columns.map((col) => {
                const group = columnGroups?.[col.name];
                const header = group && group.group !== previousGroup ? group.group : null;
                previousGroup = group?.group || "";
                return [
                    header && <ListSubheader key={`${col.name}-group`}>{header}</ListSubheader>,
                    <MenuItem key={col.name} value={col.name} sx={columnGroups ? { whiteSpace: "normal", overflowWrap: "anywhere" } : undefined}>
                        {group?.label || translateMetadataLabel(t, col)}
                    </MenuItem>,
                ];
            })}
        </TextField>
    );
};
export default FieldSelector;
